// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var badgeWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.em(0.25)),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.em(1.0)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.auto)
          ])
    ]);

var Styles = {
  badgeWrapper: badgeWrapper
};

function AppStoreBadge__Single(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: badgeWrapper
            });
}

var make = AppStoreBadge__Single;

export {
  Styles ,
  make ,
}
/* badgeWrapper Not a pure module */
